export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

export const isMobileMetamask = () =>
  isMobile() && /Metamask/i.test(navigator.userAgent);

export const isMobileWithEthereum = () => isMobile() && !!window?.ethereum;
